<script lang="ts" setup>
import { ref } from 'vue';
import storePolicy from '@store/policy';
import { findZipCode } from '@repositories/landing.repository';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const emit = defineEmits(['submitRFC']);

const store = storePolicy();
const refForm1 = ref<any>(null);
const fieldsForm2: any = ref([
  {
    key: 'tradeName',
    title: t('landing.forms.form_client_mx.nombre_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_mx.nombre_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    formatValue: (e: string) => e?.toUpperCase() ?? '',
  },
  {
    key: 'email',
    title: t('landing.forms.form_client_mx.email_del_cliente'),
    type: 'email',
    validations: {
      rules: {
        required: true,
        email: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
		 email: t('global.email_invalido'),
	  },
    },
    placeholder: t('landing.forms.form_client_mx.email_del_cliente'),
    value: store.data.email ?? null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'phone1',
    title: t('landing.forms.form_client_mx.telefono_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
        max: 12,
        min: 8,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_mx.telefono_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'companyGPSId',
    title: t('landing.forms.form_client_mx.empresa_gps'),
    selectLabel: null,
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    disabled: false,
    placeholder: t('landing.forms.form_client_mx.empresa_gps'),
    value: null,
    cols: 12,
    customClass: 'inputSelect',
    options: [],
  },
  {
    key: 'address',
    title: t('landing.forms.form_client_mx.direccion_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_mx.direccion_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'postCode',
    title: t('landing.forms.form_client_mx.codigo_postal'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_mx.codigo_postal_placeholder'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    listenChange: true,
  },
  {
    key: 'colony',
    title: t('landing.forms.form_client_mx.colonia'),
    selectLabel: null,
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_mx.colonia'),
    value: null,
    cols: 12,
    customClass: 'inputSelect',
    options: [],
  },
  {
    key: 'city',
    title: t('landing.forms.form_client_mx.ciudad'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_mx.ciudad'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    disabled: true,
  },
  {
    key: 'state',
    title: t('landing.forms.form_client_mx.estado'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_mx.estado'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    disabled: true,
  },
]);

const updateFieldsInArray = (
  array: any,
  updates: any,
  preservedValues: any,
) => {
  for (const update of updates) {
    const field = array.find((field: any) => field.key === update.key);
    if (field) {
      if ('value' in update) {
        field.value = update.value;
      }
      if ('options' in update) {
        field.options = update.options;
      }
      if ('disabled' in update) {
        field.disabled = update.disabled;
      }
    }
  }

  if (preservedValues) {
    for (const key in preservedValues) {
      const field = array.find((field: any) => field.key === key);
      if (field) {
        field.value = preservedValues[key];
      }
    }
  }
};

const handleChangeColony = async (e: any) => {
  const formProps = await refForm1.value.getValues();

  const location = await findZipCode(e.value, false);

  if (!location?.data?.length) return;

  const locations = location.data.map((loc: any) => ({
    nombre: loc.ColoniaDsc,
    id: loc.id,
  }));

  const preservedValues = {
    tradeName: formProps.items.tradeName,
    email: formProps.items.email,
    phone1: formProps.items.phone1,
    companyGPSId: formProps.items.companyGPSId,
    address: formProps.items.address,
  };

    updateFieldsInArray(
      fieldsForm2.value,
      [
        { key: 'colony', options: locations, value: { id: null } },
        { key: 'state', value: location.data[0].EstadoNombre },
        { key: 'city', value: location.data[0].MunicipioNombre },
        { key: 'postCode', value: location.data[0].code },
      ],
      preservedValues,
    );

  const values = {
    country: { id: location.data[0].PaisID },
    city: { id: location.data[0].MunicipioId },
    neighborhood: { id: location.data[0].ColoniaId },
    postCode: location.data[0].code,
    rfc: store.client.rfc,
    state: { id: location.data[0].EstadoID },
  };

  store.setProp({
    key: 'client',
    value: { ...store.client, ...values },
  });
};

defineExpose({
  fieldsForm2,
  handleChangeColony,
  updateFieldsInArray,
  getValues: () => refForm1.value?.getValues()

});
</script>

<template>
  <Form
    ref="refForm1"
    :inputs="fieldsForm2"
    @change="handleChangeColony"
  ></Form>
</template>
